import UIOverlay from 'UIComponents/overlay/UIOverlay';
import UISection from 'UIComponents/section/UISection';
import UIIllustration from 'UIComponents/image/UIIllustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSidebarOverlay = ({
  modalMessageKey = 'addModule.mobile.message.default',
  messageTitle = 'addModule.mobile.title',
  overlayClassName
}) => {
  return /*#__PURE__*/_jsx(UIOverlay, {
    className: `sidebar-mobile-overlay ${overlayClassName}`,
    contextual: true,
    use: "light",
    width: 300,
    style: {
      overflow: 'hidden'
    },
    children: /*#__PURE__*/_jsxs(UISection, {
      use: "island",
      style: {
        textAlign: 'center'
      },
      children: [/*#__PURE__*/_jsx(UIIllustration, {
        name: "lock",
        width: "40%"
      }), /*#__PURE__*/_jsx(Text, {
        as: "h5",
        marginBlock: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: messageTitle
        })
      }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: modalMessageKey
      })]
    })
  });
};
export default MobileSidebarOverlay;